module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"error-occured":"Es ist ein Fehler aufgetreten","label":"Benutzersuche"},"it":{"error-occured":"Si è verificato un errore","label":"Ricerca dell\u0027utente"},"fr":{"error-occured":"Une erreur s’est produite","label":"Recherche d’utilisateurs"}}')
  delete Component.options._Ctor
}
